(function($) {

  $( '.module-flipboxes__box--link' ).on( 'click', function( event ) {
    const $wrapper = $(this).closest('.module-flipboxes__box');
    const wrapper = $wrapper[0];

    event.preventDefault();

    if(wrapper.classList.contains('reveal')) {
      wrapper.classList.remove('reveal');
    } else {
      $('.module-flipboxes__box').removeClass('reveal');
      wrapper.classList.add('reveal');
    }
  });

}(jQuery));
